import { render, staticRenderFns } from "./Liebian.vue?vue&type=template&id=46891c54&"
import script from "./Liebian.vue?vue&type=script&lang=js&"
export * from "./Liebian.vue?vue&type=script&lang=js&"
import style0 from "./Liebian.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports